const stringToColor = (str: string, saturation = 100, lightness = 75) => {
  const string = str
    .split('')
    .map((m) => m.charCodeAt(0))
    .join('');
  let hash = 0;

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < string.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
    // eslint-disable-next-line no-bitwise
    // hash &= hash;
  }
  return `hsl(${hash % 360}, ${saturation}%, ${lightness}%)`;
};

export default stringToColor;
